__turbopack_context__.v({
  "marketplaceSellerButton": "MarketplaceSellerInfo-module-scss-module__ci_eIa__marketplaceSellerButton",
  "marketplaceSellerContainer": "MarketplaceSellerInfo-module-scss-module__ci_eIa__marketplaceSellerContainer",
  "marketplaceSellerIcon": "MarketplaceSellerInfo-module-scss-module__ci_eIa__marketplaceSellerIcon",
});
